import { PageId } from 'page-constants'
import { CookieConsentOption } from 'root-constants'

export const COOKIE_CONSENT_VIEWS = {
  BANNER: 'banner',
  PREFERENCES: 'preferences',
} as const

export const Source = {
  BANNER: 'banner',
  SETTINGS: 'cookies_settings_screen',
} as const

export type TSource = (typeof Source)[keyof typeof Source]

export const DESKTOP_CARD_WIDTH = '760px'
export const MOBILE_CONTENT_WIDTH = '375px'

export type TCookieConsentView =
  (typeof COOKIE_CONSENT_VIEWS)[keyof typeof COOKIE_CONSENT_VIEWS]

export type TCookieConsentCategory = {
  key: CookieConsentOption
  titleKey: string
  subtitleKey: string
  badgeKey?: string
}

export const ALL_COOKIE_CONSENT_TYPES = [
  CookieConsentOption.ADVERTISING_AND_TARGETING,
  CookieConsentOption.FUNCTIONAL_COOKIES,
  CookieConsentOption.ANALYTICS_AND_PERFORMANCE,
  CookieConsentOption.STRICTLY_NECESSARY,
]

export const PAGE_IDS_WITHOUT_COOKIE_CONSENT: string[] = [
  PageId.ALTERNATIVE_AYAH_LOADER,
  PageId.KNOWLEDGE_QUIZ_INTRO,
]

export const COOKIE_CONSENT_CATEGORIES: readonly TCookieConsentCategory[] = [
  {
    key: CookieConsentOption.ADVERTISING_AND_TARGETING,
    titleKey: 'cookieConsent.advertisingAndTargeting.title',
    subtitleKey: 'cookieConsent.advertisingAndTargeting.subtitle',
  },
  {
    key: CookieConsentOption.FUNCTIONAL_COOKIES,
    titleKey: 'cookieConsent.functional.title',
    subtitleKey: 'cookieConsent.functional.subtitle',
  },
  {
    key: CookieConsentOption.ANALYTICS_AND_PERFORMANCE,
    titleKey: 'cookieConsent.analyticalAndPerformance.title',
    subtitleKey: 'cookieConsent.analyticalAndPerformance.subtitle',
  },
  {
    key: CookieConsentOption.STRICTLY_NECESSARY,
    titleKey: 'cookieConsent.strictlyNecessary.title',
    subtitleKey: 'cookieConsent.strictlyNecessary.subtitle',
    badgeKey: 'cookieConsent.alwaysActive',
  },
]
